module.exports = __webpack_public_path__ + "static/media/glyphicons-halflings-regular.e18bbf61.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.ttf
// module id = 1008
// module chunks = 0